// extracted by mini-css-extract-plugin
export default {"NoRecord":"IFTable_NoRecord__FsL2-"};